import { render, staticRenderFns } from "./Ordersh.vue?vue&type=template&id=7ec77f88&scoped=true"
import script from "./Ordersh.vue?vue&type=script&lang=js"
export * from "./Ordersh.vue?vue&type=script&lang=js"
import style0 from "./Ordersh.vue?vue&type=style&index=0&id=7ec77f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec77f88",
  null
  
)

export default component.exports